module.exports = __webpack_public_path__ + "img/menu-dot-gray.6c6b65f0.svg";